/**
 * Subtle status chip for customer/workspace lifecycle states.
 */
const STYLES = {
  active:    "bg-[#10B981]/10 text-[#047857] border-[#10B981]/20",
  pending:   "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/20",
  rejected:  "bg-[#EF4444]/10 text-[#B91C1C] border-[#EF4444]/20",
  suspended: "bg-[#F97316]/10 text-[#C2410C] border-[#F97316]/20",
  archived:  "bg-[#64748B]/10 text-[#475569] border-[#64748B]/20",
};

export function StatusChip({ status, testId }) {
  const label = (status || "active").charAt(0).toUpperCase() + (status || "active").slice(1);
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full border ${STYLES[status] || STYLES.archived}`}
    >
      {label}
    </span>
  );
}
